export const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 420,
    maxWidth: '90vw',
    background: 'var(--bg-secondary)',
    backdropFilter: 'blur(20px)',
    border: '1px solid var(--border-color)',
    borderRadius: '16px',
    boxShadow: '0 0 40px rgba(0, 217, 255, 0.2)',
    padding: '32px',
    outline: 'none',
} as any;

export const modalButtonStyle = {
    width: '100%',
    padding: '14px 24px',
    fontSize: '15px',
    fontWeight: 600,
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #00d9ff, #a855f7)',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '8px',
} as any;

export const textFieldStyle = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        background: 'var(--bg-tertiary)',
        '& fieldset': {
            borderColor: 'var(--border-color)',
        },
        '&:hover fieldset': {
            borderColor: '#00d9ff',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#00d9ff',
            boxShadow: '0 0 10px rgba(0, 217, 255, 0.2)',
        },
    },
    '& .MuiInputLabel-root': {
        color: 'var(--text-secondary)',
        '&.Mui-focused': {
            color: '#00d9ff',
        },
    },
    '& .MuiOutlinedInput-input': {
        color: 'var(--text-primary)',
    },
} as any;

export const selectStyle = {
    width: '100%',
    borderRadius: '10px',
    background: 'var(--bg-tertiary)',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--border-color)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#00d9ff',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#00d9ff',
        boxShadow: '0 0 10px rgba(0, 217, 255, 0.2)',
    },
    '& .MuiSelect-select': {
        color: 'var(--text-primary)',
    },
} as any;
